import superagent from 'superagent';

export class Api {
  constructor() {
    this.url = '/api';
    this.globalErrors = [404, 500];
  }

  async get(path) {
    return await this.doRequest('get', path);
  }

  async post(path, data) {
    return await this.doRequest('post', path, data);
  }

  async put(path, data) {
    return await this.doRequest('put', path, data);
  }

  async delete(path) {
    return await this.doRequest('delete', path);
  }

  getUrl(path) {
    return this.url + path;
  }

  async postFile(file) {
    try {
      const response = await superagent
        .post(this.getUrl('/upload'))
        .attach('file', file);
      return response.body;
    } catch (error) {
      if (error.response && error.response.statusCode === 401) {
        window.location = '/';
      } else if (error.response && error.response.statusCode === 400) {
        throw error.response.body;
      } else if (error.response && error.response.statusCode === 404) {
        window.location = '/#/not-found';
      }

      throw error;
    }
  }

  async doRequest(method, path, data) {
    try {
      const req = superagent[method](this.getUrl(path));

      if (method === 'post' || method === 'put') {
        req.send(data);
      }

      const response = await req.then();
      return response.body;
    } catch (error) {
      if (error.response && error.response.statusCode === 401) {
        window.location = '/';
      } else if (error.response && error.response.statusCode === 400) {
        throw error.response.body;
      } else if (error.response && error.response.statusCode === 404) {
        window.location = '/#/not-found';
      }

      throw error;
    }
  }
}
